exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "period-list-link .periodListLink{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between;-ms-flex-align:center;-moz-align-items:center;align-items:center;width:auto;height:80px;font-size:15px;text-transform:uppercase;text-align:center;border-bottom:1px solid #dddfe2;border-top:1px solid #dddfe2;padding:0 25px;color:#0072c9}period-list-link .periodListLink p{font-family:Stag Sans;margin:0;margin-left:10px;color:#0072c9}period-list-link .periodListLink .icon-arrow-select-up{transform:rotate(90deg);font-size:14px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/vacations-absences.module/features/myVacationsMobile/periodListLink/periodListLink.scss
// module id = 1166
// module chunks = 0